<template>
  <v-card class="main-card">
    <v-card-text>
      <div id="swagger"></div>
    </v-card-text>
  </v-card>
</template>

<style scoped>
/***swagger**/
@import "/css/swagger.css";

>>> .swagger-ui .topbar {
  display: none !important;
}
>>> .swagger-ui section.models {
  display: none !important;
}
>>> .swagger-ui .info hgroup.main {
  display: none !important;
}
>>> .swagger-ui .info {
  background-color: transparent !important;
  border-color: transparent !important;
  word-break: break-all;
}
/***swagger**/

.theme--light .main-card {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 0px 15px 15px 15px;
  padding-top: 15px;
  padding-bottom: 15px;
}

.theme--dark .main-card {
  background: #212121;
  box-shadow: none;
  border-radius: 0px 15px 15px 15px;
  padding-top: 15px;
  padding-bottom: 15px;
}
</style>

<script>
import swal from "sweetalert2";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    ...mapGetters({
      themeDark: "settings/darkmode"
    }),
    themeMode: function() {
      return this.themeDark ? "dark" : "light";
    },
    isMobile() {
      return this.windowWidth < 768;
    }
  },
  mounted: async function() {
    let externalScript = document.createElement("script");
    externalScript.setAttribute(
      "src",
      "https://cdnjs.cloudflare.com/ajax/libs/swagger-ui/3.24.2/swagger-ui-bundle.js"
    );
    externalScript.onload = () => {
      let externalScript2 = document.createElement("script");
      externalScript2.setAttribute(
        "src",
        "https://cdnjs.cloudflare.com/ajax/libs/swagger-ui/3.24.2/swagger-ui-standalone-preset.js"
      );
      externalScript2.onload = () => {
        const ui = SwaggerUIBundle({
          url: "/swagger/swagger-api.json",
          dom_id: "#swagger",
          deepLinking: true,
          presets: [SwaggerUIBundle.presets.apis, SwaggerUIStandalonePreset],
          plugins: [SwaggerUIBundle.plugins.DownloadUrl],
          layout: "StandaloneLayout"
        });
        window.ui = ui;
      };
      document.head.appendChild(externalScript2);
    };
    document.head.appendChild(externalScript);
  },
  created: async function() {},
  methods: {
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/whitelabel/Documentation.vue